import React from "react";

import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";
import { Space } from "antd";
import classNames from "classnames";

import { getVeriffUrl } from "api/kyc";
import { DocumentSuccessSVG } from "assets/icons";
import { BackButton } from "components/BackButton";
import { ConfirmButton } from "components/ConfirmButton";
import { SubmitButton } from "components/SubmitButton";
import { HOME_PATH } from "constants/pages";
import { useMutateKyc, useStepsProgress } from "hooks";

import { reportVeriffError } from "./reportVeriffError";

import styles from "./ProofOfIdentityCreated.module.scss";

export const ProofOfIdentityCreated = () => {
  const { goToNextScreen, setStepsPercent, setCurrentStep } = useStepsProgress();
  const updateKyc = useMutateKyc();

  const handleNext = () => {
    updateKyc
      .mutateAsync({ currentStep: 3 })
      .then(() => {
        setCurrentStep(3);
        goToNextScreen();
      })
      .catch((error) => reportVeriffError("Failed to continue after confirmed Proof of Identity", error));
  };

  const header = "Your Proof of Identity has been confirmed";
  const paragraph = "You may continue to next stage";

  const handleVeriffConfirm = () => {
    getVeriffUrl()
      .then(({ url }) => {
        setStepsPercent(15);

        try {
          createVeriffFrame({
            url,
            onEvent: (msg) => {
              switch (msg) {
                case MESSAGES.FINISHED: {
                  updateKyc
                    .mutateAsync({ currentStep: 3 })
                    .then(() => {
                      setCurrentStep(3);
                      goToNextScreen();
                    })
                    .catch((error) => {
                      setStepsPercent(5);
                      reportVeriffError("Failed to update KYC after Veriff restart finished", error);
                    });
                  break;
                }
                case MESSAGES.CANCELED: {
                  setStepsPercent(5);
                  break;
                }
              }
            },
          });
        } catch (error) {
          setStepsPercent(5);
          reportVeriffError("Failed to open Veriff restart frame", error);
        }
      })
      .catch((error) => {
        setStepsPercent(5);
        reportVeriffError("Failed to fetch Veriff restart URL", error);
      });
  };

  const confirmationProps = {
    className: classNames([styles.resetVeriffButton, styles.margin0]),
    onConfirmHandler: handleVeriffConfirm,
    title: "Veriff session reset",
    content: "This action will override your current Veriff session. Are you sure you want to proceed?",
  };

  return (
    <div className={styles.proofOfIdentityCreated}>
      <h2>{header}</h2>
      <p>{paragraph}</p>
      <div className={styles.documentIconContainer}>{<DocumentSuccessSVG />}</div>

      <Space align='center' className={styles.actions} direction='vertical' size={0}>
        <SubmitButton onClick={handleNext}>Continue</SubmitButton>

        <BackButton href={HOME_PATH} className={styles.backToDashboard}>
          Back to Dashboard
        </BackButton>

        <ConfirmButton {...confirmationProps} className={styles.resetVeriffButton}>
          Restart Proof Of Identity Verification
        </ConfirmButton>
      </Space>
    </div>
  );
};
